// remembers what the last signed-in agent saw, so the login screen can already show
// the right branding. kept out of the 'redux' blob on purpose: that one is reset by
// CLEAN_USER on logout, which is exactly when this value has to survive
import { LOGO_TONES, normalizeLogoUrl } from 'helpers/brandLogo';

// v2 holds one url per tone; the v1 key held a single string and is simply ignored
export const AGENCY_LOGO_KEY = 'sunshine_agency_logos_v2';

const EMPTY_LOGOS = Object.freeze(
  Object.fromEntries(LOGO_TONES.map(tone => [tone, '']))
);

function normalizeLogoSet(value) {
  if (!value || typeof value !== 'object') return { ...EMPTY_LOGOS };
  return Object.fromEntries(
    LOGO_TONES.map(tone => [tone, normalizeLogoUrl(value[tone])])
  );
}

/**
 * what the last signed-in agent saw. hasRecord false means nobody has signed in on
 * this browser yet; hasRecord true with empty urls means that agent's agency had no
 * logo of its own, so the bundled brand asset is the right thing to show
 * @param storage - Storage-like object with getItem, defaults to window.localStorage
 * @returns {{ hasRecord: boolean, logos: { onLight: string, onDark: string } }}
 */
export function readRememberedAgencyLogos(storage = globalThis.localStorage) {
  try {
    const raw = storage?.getItem(AGENCY_LOGO_KEY);
    if (!raw) return { hasRecord: false, logos: { ...EMPTY_LOGOS } };
    return { hasRecord: true, logos: normalizeLogoSet(JSON.parse(raw)) };
  } catch (error) {
    console.warn('failed to read the remembered agency logos', error);
    return { hasRecord: false, logos: { ...EMPTY_LOGOS } };
  }
}

/**
 * stores the agency logos of the agent that just loaded. an agency with no logo of
 * its own is still written, as an empty record: that both overwrites the previous
 * agent's branding and marks that somebody has signed in on this browser
 * @param logos - { onLight, onDark } urls
 * @param storage - Storage-like object, defaults to window.localStorage
 */
export function writeRememberedAgencyLogos(
  logos,
  storage = globalThis.localStorage
) {
  try {
    storage?.setItem(AGENCY_LOGO_KEY, JSON.stringify(normalizeLogoSet(logos)));
  } catch (error) {
    console.warn('failed to store the remembered agency logos', error);
  }
}
